import React, { useMemo } from 'react'
import { useLocation } from 'react-router'
import MyRecords from './MyRecords'
import MiscellaneousMyRecords from '../MiscRecords/MiscellaneousMyRecords'

const MyRecordsWrapper = (props) => {
  const location = useLocation()
  const { sublinks } = props

  const isMiscRecordsType = useMemo(() => {
    const parts = location.pathname.split('/')
    const sublink = (sublinks || []).find((x) => x.parameter === parts[parts.length - 1])
    return sublink ? !!sublink.IsMiscRecordsType : false
  }, [location, sublinks])

  if (isMiscRecordsType) return <MiscellaneousMyRecords {...props} />
  return <MyRecords {...props} />
}

export default MyRecordsWrapper
